import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import SwalServices from '../../../services/swalServices/SwalServices';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { MaterialJobWorkPopup } from './MaterialJobWorkTable';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { decryptAES } from '../../../utils/Encryption';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class MaterialJobWork extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColdefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            partyAccountList: [],
            accountHeadList: [],
            employeeList: [],
            itemCategoryList: [],
            taxStructureList: [],
            plantList: [],
            processList: [],
            itemList: [],
            isSelectItemPopUp: false,
            roleId: null,
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            types: [
                {
                    value: 1,
                    label: "RAW MATERIAL"
                },
                {
                    value: 2,
                    label: "FINISHED GOODS"
                },
                {
                    value: 3,
                    label: "SEMI FINISHED"
                },
            ],
            jobWorkFromLIst: [
                { value: 1, label: 'FROMTESTING' },
                { value: 2, label: 'REWORKCHALLAN' },
                { value: 3, label: 'FromDisAssemble' },
                { value: 4, label: 'JOBWORKCHALLAN' },
                { value: 5, label: 'MANUALLY' },
            ],
            invTyleList: [
                { value: 1, label: 'INTRASTATE' },
                { value: 2, label: 'INTERSTATE' },
            ],
            companyName: "",
            materialObject: {
                idMaterialJobWork: 0,
                idInvType: 1,
                updateStatus: 0,
                jobWorkNo: '',
                jobWorkDate: '',
                idJobWorkFrom: 0,
                refNo: '',
                idVendor: 0,
                idEmployee: 0,
                inwardNo: '',
                inwardDate: '',
                testingNo: '',
                fromTask: '',
                transporter: '',
                remarks: '',
                jobWorkNature: '',
                inspection: '',
                deliveryCommence: "",
                idProcess: "",
                idPlant: '',
                idAccountHead: 0,
                address: "",
                noOfLotsMax: '',

                totalQty: '',
                totalAmt: '',
                extraCharges: '',
                totalwithTax: '',
                taxAmt: '',
                discount: '',
                finalAmt: '',
                taxableAmt: '',
                adjustableAmt: 0,
                email: "",
            },
            itemObject: {
                drawingNo: "",
                idItem: "",
                itemIdLabel: "",
                itemName: '',
                quantity: "",
                avlStock: "",
                discount: "",
                discountAmt: "",
                extraCharges: "",
                taxableAmt: "",
                idTaxGroup: 0,
                sgst: 0,
                cgst: 0,
                igst: 0,
                sgstAmt: "",
                cgstAmt: "",
                igstAmt: "",
                netTotal: "",
                remarks: "",
                actualRate: "",
                rate: "",
                amount: "",

                idType: 0,
                size: "",
                taxableAmt: "",
                index: null,
                inwardStatus: false,
            },
            paymentDetails: {
                totalQuantity: "",
                totalAmt: "",
                extraCharges: "",
                disAmt: "",
                taxAmt: "",
                totalTaxAmt: "",
                finalAmt: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                jobWorkDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                idJobWorkFrom: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                idAccountHead: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "general product"
                        ),
                    },
                ],
            },
            validationRules: {
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, roleId: prop.roleId, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect();
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Job Work",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                this.setPermissions(permissions);
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            pinned: ["jobWorkNo", "jobWorkDate", "jobWorkFrom", "vendor"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialJobWork", "sR.No"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Job Work",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "Material Job Work");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "contactNo": window.innerWidth * 0.08,
            "contactPerson": window.innerWidth * 0.1,
            "inwardNo": window.innerWidth * 0.06,
            "totalQty": window.innerWidth * 0.06,
            "totalAmt": window.innerWidth * 0.08,
            "extraCharges": window.innerWidth * 0.05,
            "discount": window.innerWidth * 0.05,
            "taxAmt": window.innerWidth * 0.05,
            "finalAmt": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
            "variationStatus": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            "jobWorkNo": window.innerWidth * 0.05,
            "jobWorkDate": window.innerWidth * 0.08,
            "jobWorkFrom": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.15,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));

                        let filteredData = this.state.roleId !== 1 ? dynamicData.filter((x) => x.pendingQty > 0) : dynamicData
                        this.setState({
                            table2Data: filteredData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.2,
            "hsnCode": window.innerWidth * 0.06,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.04,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.04,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.04,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
            "isVariation": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                        this.getMasterAccountHeadSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getMasterAccountHeadSelect();
                }
            }
        });
    }

    getMasterAccountHeadSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idGeneralProduct,
                    label: x.productName,
                }))
                    .filter((x) => x.label === 'JOB WORK');
                this.setState({ accountHeadList: data }, () => {
                    this.getEmployeeList()
                });
            } else {
                this.getEmployeeList();
            }
        });
    }

    getEmployeeList = () => {
        this.accountTransactionServices.usp_Master_EmployeeSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idEmployee,
                    label: x.employeeName,
                }));
                this.setState({ employeeList: data }, () => {
                    this.getItemCategoryList();
                });
            } else {
                this.getItemCategoryList();
            }
        });
    }


    getItemCategoryList = () => {
        this.transactionStockServices.usp_Master_ItemCategorySelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idItemCategory,
                    label: x.itemCategory,
                }));
                this.setState({ itemCategoryList: data }, () => {
                    this.getTaxStructureList();
                });
            } else {
                this.getTaxStructureList();
            }
        });
    }

    getTaxStructureList = () => {
        let request = {
            formname: "Tax Structure Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[1];
                data = data.map((x) => ({
                    idTaxStructure: x.idTaxStructure,
                    label: x.taxStructureName,
                    value: x.idTaxStructure,
                    sgst: x.sgst ? x.sgst : 0,
                    cgst: x.cgst ? x.cgst : 0,
                    igst: x.igst ? x.igst : 0
                }));
                this.setState({ taxStructureList: data }, () => {
                    this.getPlantList();
                })
            } else {
                this.getPlantList();
            }
        });
    }

    getPlantList = () => {
        this.transactionStockServices.usp_Master_PlantSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idPlant,
                    label: x.plantDetails,
                }));
                this.setState({ plantList: data }, () => {
                    this.getProcessList();
                });
            } else {
                this.getProcessList();
            }
        });
    }

    getProcessList = () => {
        this.transactionStockServices.usp_Master_ProcessSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idProcess,
                    label: x.process,
                }));
                this.setState({ processList: data }, () => {
                    // this.getTaxStructureList();
                });
            } else {
                // this.getTaxStructureList();
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.transactionStockServices.getInvoiceCountForMaterialJobWork(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let taxableAmt = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (taxableAmt.toString().length === 1) {
                    formatted = '00' + taxableAmt;
                } else if (taxableAmt.toString().length === 2) {
                    formatted = '0' + taxableAmt;
                } else {
                    formatted = taxableAmt.toString();
                }
                let materialObject = this.state.materialObject
                materialObject.jobWorkNo = formatted
                this.setState({ materialObject: materialObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.resetItemDetailsFields()
                        // this.resetInvoiceItems()
                        this.setState({ invoiceRowData: [] })
                    })
                })
            }
        });
    };

    getMaster_ItemSelectbyItemType = (label, name) => {
        let request = [this.state.idCompany, label, this.state.materialObject.idVendor];
        this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.setState({
                    itemList: data,
                });
            }
        });
    }

    openPopUpFromURLId = (id) => {
        this.getTransactionMaterialJobWorkSelectbyID(id);
    }

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getTransactionMaterialJobWorkSelectbyID(event.data.idMaterialJobWork);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details }, () => {
            this.calculateTotalForWork()
        });
    }

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details }, () => {
            if (name === 'quantity' || name === 'rate' || name === 'discount' || name === 'extraCharges') {
                this.calculateTotal();
            }
        });
    }

    resetDetailsFields = () => {
        let materialObject = this.state.materialObject;
        materialObject.idMaterialJobWork = 0;
        materialObject.idInvType = 1;
        materialObject.jobWorkDate = '';
        materialObject.idJobWorkFrom = 0;
        materialObject.refNo = '';
        materialObject.idVendor = 0;
        materialObject.idEmployee = 0;
        materialObject.inwardNo = '';
        materialObject.inwardDate = '';
        materialObject.testingNo = '';
        materialObject.fromTask = '';
        materialObject.transporter = '';
        materialObject.remarks = '';
        materialObject.jobWorkNature = '';
        materialObject.inspection = '';
        materialObject.deliveryCommence = "";
        materialObject.idProcess = "";
        materialObject.idPlant = '';
        materialObject.idAccountHead = 0;
        materialObject.address = "";
        materialObject.noOfLotsMax = '';

        materialObject.totalQty = '';
        materialObject.totalAmt = '';
        materialObject.extraCharges = '';
        materialObject.totalwithTax = '';
        materialObject.taxAmt = '';
        materialObject.discount = '';
        materialObject.finalAmt = '';
        materialObject.taxableAmt = '';
        materialObject.adjustableAmt = '';

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            materialObject: materialObject,
            itemRowData: []
        });
    }

    handleCellClick = (event) => {
        let data = this.state.materialObject;
        data.idMaterialJobWork = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ materialObject: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Material Job Work");
    };

    setFilterParametersForWork = (event, name) => {
        let details = this.state.materialObject;
        details[name] = event.value;
        if (name === 'idVendor') {
            details.address = event.partyAddress;
        }
        this.setState({ materialObject: details }, () => {
            if (name === 'idVendor') {
                this.getPartyAccountSelectbyID()
            }
        });
    }

    getPartyAccountSelectbyID = () => {
        if (this.state.materialObject.idVendor > 0) {
            this.accountTransactionServices.getPartyAccountSelectbyID(this.state.materialObject.idVendor).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    let data = this.state.materialObject;
                    data.idInvType = this.state.invTyleList.find(x => x.label === res.invoiceType) ? this.state.invTyleList.find(x => x.label === res.invoiceType).value : 1;
                    this.setState({ materialObject: data });
                }
            });
        }
    }

    setFilterParameters = (event, name) => {
        let details = this.state.itemObject;
        details[name] = event.value;
        if (name === 'idType') {
            details.idItem = 0;
            this.getMaster_ItemSelectbyItemType(event.label)
        }
        if (name === 'idItem') {
            details.itemName = event.label;
            this.usp_Master_ItemSelectbyID_JobWork(event.value);
        }
        this.setState({ itemObject: details }, () => {
            if (name === 'idTaxGroup') {
                this.calculateTotal();
            }
        });
    }

    usp_Master_ItemSelectbyID_JobWork = (id) => {
        let request = {
            idItem: id,
            idVendor: this.state.materialObject.idVendor,
        }
        if (id !== 0 && this.state.materialObject.idVendor !== 0) {
            this.transactionStockServices.usp_Master_ItemSelectbyID_JobWork(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent[0];
                    let details = this.state.itemObject;
                    details.size = data.sizeName ? data.sizeName : "";
                    details.idTaxGroup = data.idTaxGroup ? data.idTaxGroup : 0;
                    details.actualRate = data.itemRate ? data.itemRate : 0;
                    details.rate = data.finalItemRate ? data.finalItemRate : 0;
                    details.avlStock = data.avlStock ? data.avlStock : 0;
                    details.drawingNo = data.drawingNo ? data.drawingNo : "";
                    this.setState({ itemObject: details })
                }
            });
        }
    }

    calculateTotal = () => {
        let itemObject = { ...this.state.itemObject };

        let qty = Number(itemObject.quantity) || 0;
        let rate = Number(itemObject.rate) || 0;
        let discount = Number(itemObject.discount) || 0;
        let extraCharges = Number(itemObject.extraCharges) || 0;

        let baseAmount = qty * rate;

        let discountAmt = (baseAmount * discount) / 100;
        let amountAfterDiscount = Math.max(baseAmount - discountAmt, 0);

        let taxableAmt = amountAfterDiscount + extraCharges;

        let sgstAmt = 0, cgstAmt = 0, igstAmt = 0;
        let sgst = 0, cgst = 0, igst = 0;

        if (itemObject.idTaxGroup > 0) {
            let tax = this.state.taxStructureList.find(x => x.idTaxStructure === itemObject.idTaxGroup);
            if (tax) {
                sgst = tax.sgst || 0;
                cgst = tax.cgst || 0;
                igst = tax.igst || 0;

                if (this.state.materialObject.idInvType === 1) {
                    sgstAmt = (taxableAmt * sgst) / 100;
                    cgstAmt = (taxableAmt * cgst) / 100;
                } else if (this.state.materialObject.idInvType === 2) {
                    igstAmt = (taxableAmt * igst) / 100;
                }
            }
        }

        let taxAmt = sgstAmt + cgstAmt + igstAmt;

        let netTotal = taxableAmt + taxAmt;

        itemObject.baseAmount = baseAmount.toFixed(2);
        itemObject.amount = baseAmount.toFixed(2);
        itemObject.discountAmt = discountAmt.toFixed(2);
        itemObject.amountAfterDiscount = amountAfterDiscount.toFixed(2);
        itemObject.extraCharges = extraCharges;
        itemObject.taxableAmt = taxableAmt.toFixed(2);

        itemObject.sgst = sgst + "%";
        itemObject.cgst = cgst + "%";
        itemObject.igst = igst + "%";
        itemObject.sgstAmt = sgstAmt.toFixed(2);
        itemObject.cgstAmt = cgstAmt.toFixed(2);
        itemObject.igstAmt = igstAmt.toFixed(2);

        itemObject.taxAmt = taxAmt.toFixed(2);
        itemObject.netTotal = netTotal.toFixed(2);

        this.setState({ itemObject }, () => {
            this.calculateTotalForWork()
        });
    };


    insertItem = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let data = [...this.state.itemRowData];
            let itemObject = this.state.itemObject;
            if (itemObject.quantity <= itemObject.avlStock && itemObject.avlStock > 0) {
                let itemRowData = {};
                itemRowData.idItem = itemObject.idItem;
                itemRowData.quantity = Number(itemObject.quantity);
                itemRowData.itemName = itemObject.itemIdLabel;
                itemRowData.size = itemObject.size ? itemObject.size : "";
                itemRowData.avlStock = Number(itemObject.avlStock);
                itemRowData.drawingNo = itemObject.drawingNo;
                itemRowData.weight = itemObject.weight ? Number(itemObject.weight) : 0;
                itemRowData.discount = itemObject.discount ? Number(itemObject.discount) : 0;
                itemRowData.extraCharges = itemObject.extraCharges ? Number(itemObject.extraCharges) : 0;
                itemRowData.taxableAmt = itemObject.taxableAmt ? Number(itemObject.taxableAmt) : 0;
                itemRowData.idTaxGroup = itemObject.idTaxGroup;
                itemRowData.sgst = itemObject.sgst ? itemObject.sgst : "0.00";
                itemRowData.cgst = itemObject.cgst ? itemObject.cgst : "0.00";
                itemRowData.igst = itemObject.igst ? itemObject.igst : "0.00";
                itemRowData.sgstAmt = itemObject.sgstAmt ? Number(itemObject.sgstAmt) : "0.00";
                itemRowData.cgstAmt = itemObject.cgstAmt ? Number(itemObject.cgstAmt) : "0.00";
                itemRowData.igstAmt = itemObject.igstAmt ? Number(itemObject.igstAmt) : "0.00";
                itemRowData.netTotal = itemObject.netTotal ? Number(itemObject.netTotal) : "0.00";
                itemRowData.remarks = itemObject.remarks;
                itemRowData.idMaterialTestingProducts = 0;
                itemRowData.idMaterialTesting = 0;
                itemRowData.idMaterialIssueJobWork = 0;
                itemRowData.natureOJobWork = itemObject.natureOJObWork ? itemObject.natureOJObWork : "";
                itemRowData.issueNo = ''
                itemRowData.rate = itemObject.rate ? Number(itemObject.rate) : 0;
                itemRowData.amount = itemObject.amount ? Number(itemObject.amount) : 0;
                itemRowData.actualRate = itemObject.actualRate ? Number(itemObject.actualRate) : 0;
                itemRowData.idMaterialJobWorkItems = 0;
                itemRowData.idDisAssemble = 0;
                itemRowData.idDisAssembleItems = 0;
                itemRowData.discountAmt = itemObject.discountAmt ? Number(itemObject.discountAmt) : 0;
                itemRowData.taxAmt = itemObject.taxAmt ? Number(itemObject.taxAmt) : 0;

                if (itemObject.index !== null && itemObject.index >= 0) {
                    data[itemObject.index] = itemRowData;
                } else {
                    data.push(itemRowData);
                }
                this.setState({ itemRowData: data }, () => {
                    this.resetItemDetailsFields();
                    this.calculateTotalForWork();
                });
            } else {
                this.SwalServices.Error("Quantity should not be greater than available stock");
            }
        }
    }

    resetItemDetailsFields = () => {
        let itemObject = this.state.itemObject;
        itemObject.drawingNo = "";
        itemObject.idItem = "";
        itemObject.itemIdLabel = "";
        itemObject.itemName = "";
        itemObject.quantity = "";
        itemObject.avlStock = "";
        itemObject.discount = "";
        itemObject.extraCharges = "";
        itemObject.taxableAmt = "";
        itemObject.idTaxGroup = 0;
        itemObject.sgst = "0.00";
        itemObject.cgst = "0.00";
        itemObject.igst = "0.00";
        itemObject.sgstAmt = "0.00";
        itemObject.cgstAmt = "0.00";
        itemObject.igstAmt = "0.00";
        itemObject.netTotal = "0.00";
        itemObject.remarks = "";
        itemObject.actualRate = "";
        itemObject.rate = "";
        itemObject.amount = "";
        itemObject.index = null;
        itemObject.size = "";
        itemObject.taxableAmt = "";
        itemObject.natureOJObWork = "";
        itemObject.issueNo = "";
        itemObject.idMaterialJobWorkItems = 0;
        itemObject.idDisAssemble = 0;
        itemObject.idDisAssembleItems = 0;
        itemObject.idMaterialTestingProducts = 0;
        itemObject.idMaterialTesting = 0;
        itemObject.idMaterialIssueJobWork = 0;
        itemObject.idMaterialJobWorkItems = 0;
        itemObject.idMaterialJobWorkItems = 0;

        this.setState({ itemObject: itemObject });
    }

    calculateTotalForWork = () => {
        let itemRowData = this.state.itemRowData;

        let totalQuantity = 0;
        let totalBaseAmt = 0;
        let totalDiscountAmt = 0;
        let totalExtraCharges = 0;
        let totalTaxableAmt = 0;
        let totalSgstAmt = 0;
        let totalCgstAmt = 0;
        let totalIgstAmt = 0;
        let totalNetAmt = 0;

        itemRowData.forEach((item) => {
            totalQuantity += Number(item.quantity || 0);
            const qty = Number(item.quantity || 0);
            const rate = Number(item.itemRate || item.rate || 0);
            const baseAmount = qty * rate;
            const discountPerItem = (baseAmount * Number(item.discount || 0)) / 100;

            totalBaseAmt += Number(item.amount || 0);
            totalDiscountAmt += Number(discountPerItem || 0);
            totalExtraCharges += Number(item.extraCharges || 0);
            totalTaxableAmt += Number(item.taxableAmt || 0);
            totalSgstAmt += Number(item.sgstAmt || 0);
            totalCgstAmt += Number(item.cgstAmt || 0);
            totalIgstAmt += Number(item.igstAmt || 0);
            totalNetAmt += Number(item.netTotal || 0);
        });

        let materialObject = { ...this.state.materialObject };
        let adjustableAmt = Number(materialObject.adjustableAmt) || 0;

        let finalAmt = Math.round(totalNetAmt + adjustableAmt);

        materialObject.totalQty = totalQuantity.toFixed(2);
        materialObject.totalAmt = totalBaseAmt.toFixed(2);
        materialObject.discount = totalDiscountAmt.toFixed(2);
        materialObject.extraCharges = totalExtraCharges.toFixed(2);
        materialObject.taxableAmt = totalTaxableAmt.toFixed(2);
        materialObject.taxAmt = (totalSgstAmt + totalCgstAmt + totalIgstAmt).toFixed(2);
        materialObject.totalwithTax = totalNetAmt.toFixed(2);
        materialObject.finalAmt = finalAmt.toFixed(2);

        this.setState({ materialObject });
    };

    onRowDoubleClickedForSalaryDetails = (event) => {
        let details = event.data
        let itemObject = this.state.itemObject
        itemObject = details
        itemObject.itemIdLabel = details.itemName
        itemObject.itemCategoryDesc = this.state.itemList.find(x => x.idItem === details.idItem)?.itemCategoryDesc
        itemObject.idType = itemObject.itemCategoryDesc ? this.state.types.find(x => x.label === itemObject.itemCategoryDesc).value : ''
        itemObject.amount = Number(details.amount).toFixed(2)
        itemObject.taxableAmt = Number(details.taxableAmt).toFixed(2)
        itemObject.sgstAmt = Number(details.sgstAmt).toFixed(2)
        itemObject.cgstAmt = Number(details.cgstAmt).toFixed(2)
        itemObject.igstAmt = Number(details.igstAmt).toFixed(2)
        itemObject.netTotal = Number(details.netTotal).toFixed(2)
        itemObject.index = event.rowIndex
        itemObject.inwardStatus = details.inwardStatus;
        this.setState({ itemObject: itemObject })

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };

    deleteItem = () => {
        let details = this.state.itemObject
        let data = [...this.state.itemRowData];
        data.splice(details.index, 1);
        this.setState({ itemRowData: data }, () => {
            this.calculateTotalForWork();
            this.resetItemDetailsFields();
        })
    }


    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFieldsForWork();
        if (isValidAllFields) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Error("Please add jobwork details.");
            } else {
                let details = this.state.materialObject;
                let details2 = this.state.itemRowData;
                let materialJobWorkItemList = [];
                details2.map((x) => {
                    let request = {
                        fromTask: x.fromTask ? x.fromTask : "",
                        formReturnId: 0,
                        idItem: x.idItem,
                        quantity: x.quantity,
                        itemName: x.itemName,
                        avlStock: x.avlStock,
                        weight: x.weight ? x.weight : 0,
                        discount: x.discount ? x.discount : 0,
                        extraCharges: x.extraCharges ? x.extraCharges : 0,
                        taxableAmt: x.taxableAmt ? x.taxableAmt : 0,
                        idTaxGroup: x.idTaxGroup,
                        sgst: x.sgst ? x.sgst.replace('%', '') : 0,
                        cgst: x.cgst ? x.cgst.replace('%', '') : 0,
                        igst: x.igst ? x.igst.replace('%', '') : 0,
                        sgstAmt: x.sgstAmt ? Number(x.sgstAmt).toFixed(2) : 0,
                        cgstAmt: x.cgstAmt ? Number(x.cgstAmt).toFixed(2) : 0,
                        igstAmt: x.igstAmt ? Number(x.igstAmt).toFixed(2) : 0,
                        netTotal: x.netTotal ? Number(x.netTotal).toFixed(2) : 0,
                        remarks: x.remarks ? x.remarks : "",
                        idMaterialTestingProducts: x.idMaterialTestingProducts ? x.idMaterialTestingProducts : 0,
                        idMaterialTesting: x.idMaterialTesting ? x.idMaterialTesting : 0,
                        idMaterialIssueJobWork: x.idMaterialIssueJobWork ? x.idMaterialIssueJobWork : 0,
                        natureOJObWork: x.natureOJObWork ? x.natureOJObWork : "",
                        issueNo: x.issueNo ? x.issueNo : "",
                        rate: x.rate ? x.rate : 0,
                        amount: x.amount ? x.amount : 0,
                        actualRate: x.actualRate ? x.actualRate : 0,
                        idMaterialJobWorkItems: x.idMaterialJobWorkItems ? x.idMaterialJobWorkItems : 0,
                        idDisAssemble: x.idDisAssemble ? x.idDisAssemble : 0,
                        idDisAssembleItems: x.idDisAssembleItems ? x.idDisAssembleItems : 0,
                    }
                    materialJobWorkItemList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        idMaterialJobWork: details.idMaterialJobWork ? details.idMaterialJobWork : 0,
                        updateStatus: details.updateStatus ? details.updateStatus : 0,
                        invoiceType: details.idInvType ? this.state.invTyleList.find(x => x.value === details.idInvType).label : "",
                        jobWorkNo: details.jobWorkNo ? details.jobWorkNo : "",
                        jobWorkDate: (details.jobWorkDate && details.jobWorkDate !== 'Invalid date') ? details.jobWorkDate : null,
                        jobworkFrom: details.idJobWorkFrom ? this.state.jobWorkFromLIst.find(x => x.value === details.idJobWorkFrom).label : "",
                        refNo: details.refNo ? details.refNo : "",
                        idVendor: details.idVendor ? details.idVendor : 0,
                        idEmployee: details.idEmployee ? details.idEmployee : 0,
                        inwardNo: details.inwardNo ? details.inwardNo : "",
                        inwardDate: (details.inwardDate && details.inwardDate !== 'Invalid date') ? details.inwardDate : null,
                        testingNo: details.testingNo ? details.testingNo : "",
                        fromTask: details.fromTask ? details.fromTask : "",
                        idMaterialTesting: details.idMaterialTesting ? details.idMaterialTesting : 0,
                        idMaterialIssueJobWork: details.idMaterialIssueJobWork ? details.idMaterialIssueJobWork : 0,
                        formReturnId: details.formReturnId ? details.formReturnId : 0,
                        transporter: details.transporter ? details.transporter : "",
                        remarks: details.remarks ? details.remarks : "",
                        jobWorkNature: details.jobWorkNature ? details.jobWorkNature : "",
                        inspection: details.inspection ? details.inspection : "",
                        deliveryCommence: details.deliveryCommence ? details.deliveryCommence : "",
                        noOfLotsMax: details.noOfLotsMax ? details.noOfLotsMax : 0,

                        totalQty: details.totalQty ? Number(details.totalQty).toFixed(2) : 0,
                        totalAmt: details.totalAmt ? Number(details.totalAmt).toFixed(2) : 0,
                        taxAmt: details.taxAmt ? Number(details.taxAmt).toFixed(2) : 0,
                        totalwithTax: details.totalwithTax ? Number(details.totalwithTax).toFixed(2) : 0,
                        extraCharges: details.extraCharges ? Number(details.extraCharges).toFixed(2) : 0,
                        discount: details.discount ? Number(details.discount).toFixed(2) : 0,
                        finalAmt: details.finalAmt ? Number(details.finalAmt).toFixed(2) : 0,

                        idCompany: this.state.idCompany,
                        e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updateStatus > 0 ? new Date().toISOString() : null,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        idCompanyDivision: 0,
                        idPlant: details.idPlant ? details.idPlant : 0,
                        idProcess: details.idProcess ? details.idProcess : 0,
                        idAccountHead: details.idAccountHead ? details.idAccountHead : 0,
                        taxableAmt: details.taxableAmt ? Number(details.taxableAmt).toFixed(2) : 0,
                        adjustableAmt: details.adjustableAmt ? Number(details.adjustableAmt) : 0,
                        materialJobWorkItemList: materialJobWorkItemList
                    }
                    this.isSubmitting = true;
                    this.setState({ isSaving: true });
                    this.transactionStockServices.submitMaterialJobWorkInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.materialObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    this.resetDetailsFields();
                                    // Call resetFields here after submission
                                    this.setState(
                                        { isModalOpen: false },
                                        () => {
                                            this.procSelectAllRecordsSP(); // Fetch latest records
                                        }
                                    );
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        }).finally(() => {
                            this.isSubmitting = false;
                            this.setState({ isSaving: false });
                        });
                }
            }
        }
    }

    getTransactionMaterialJobWorkSelectbyID = (id) => {
        this.transactionStockServices.getTransactionMaterialJobWorkSelectbyID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    let data = this.state.materialObject;
                    data.idMaterialJobWork = res.idMaterialJobWork ? res.idMaterialJobWork : 0
                    data.idInvType = res.invoiceType ? this.state.invTyleList.find(x => x.label === res.invoiceType).value : ""
                    data.jobWorkNo = res.jobWorkNo ? res.jobWorkNo : ""
                    data.jobWorkDate = res.jobWorkDate ? moment(res.jobWorkDate).format('YYYY-MM-DD') : ''
                    data.idJobWorkFrom = res.jobWorkFrom ? this.state.jobWorkFromLIst.find(x => x.label === res.jobWorkFrom)?.value : ""
                    data.refNo = res.refNo ? res.refNo : ""
                    data.idVendor = res.idVendor ? res.idVendor : 0
                    data.address = res.idVendor ? this.state.partyAccountList.find(x => x.value === res.idVendor)?.partyAddress : "";
                    data.idEmployee = res.idEmployee ? res.idEmployee : 0
                    data.inwardNo = res.inwardNo ? res.inwardNo : ""
                    data.inwardDate = res.inwardDate ? moment(res.inwardDate).format('YYYY-MM-DD') : ''
                    data.testingNo = res.testingNo ? res.testingNo : ""
                    data.fromTask = res.fromTask ? res.fromTask : ""
                    data.transporter = res.transporter ? res.transporter : ""
                    data.remarks = res.remarks ? res.remarks : ""
                    data.jobWorkNature = res.jobWorkNature ? res.jobWorkNature : ""
                    data.inspection = res.inspection ? res.inspection : ""
                    data.deliveryCommence = res.deliveryCommence ? res.deliveryCommence : ""
                    data.noOfLotsMax = res.noOfLotsMax ? res.noOfLotsMax : 0
                    data.totalQty = res.totalQty ? res.totalQty : 0
                    data.totalAmt = res.totalAmt ? res.totalAmt : 0
                    data.taxAmt = res.taxAmt ? res.taxAmt : 0
                    data.totalwithTax = res.totalwithTax ? res.totalwithTax : 0
                    data.extraCharges = res.extraCharges ? res.extraCharges : 0
                    data.discount = res.discount ? res.discount : 0
                    data.finalAmt = res.finalAmt ? res.finalAmt : 0
                    data.idPlant = res.idPlant ? res.idPlant : 0
                    data.idProcess = res.idProcess ? res.idProcess : 0
                    data.updateStatus = 1
                    data.idAccountHead = res.idGeneralProduct ? res.idGeneralProduct : 0
                    data.taxableAmt = res.taxableAmt ? res.taxableAmt : 0
                    data.adjustableAmt = res.adjustableAmt ? res.adjustableAmt : 0
                    data.email = res.emailID ? res.emailID : "";
                    this.setState({
                        materialObject: data,
                        isModalOpen: true,
                        globalUserID: res.modifiedBy
                    });
                    this.transactionStockServices.getTransactionMaterialJobWorkItemsSelectbyID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            let materialJobWorkItemList = [];
                            this.getMaster_ItemSelectbyItemType('', '')
                            if (value.length > 0) {
                                value.map((x) => {
                                    let request = {
                                        drawingNo: x.drawingNo ? x.drawingNo : "",
                                        fromTask: x.fromTask ? x.fromTask : "",
                                        idItem: x.idItem,
                                        quantity: x.quantity,
                                        itemName: x.itemName,
                                        avlStock: x.avlStock,
                                        weight: x.weight ? x.weight : 0,
                                        discount: x.discount ? x.discount : 0,
                                        extraCharges: x.extraCharges ? x.extraCharges : 0,
                                        taxableAmt: x.taxableAmt ? x.taxableAmt : 0,
                                        idTaxGroup: x.idTaxGroup,
                                        sgst: x.sgst ? x.sgst + '%' : 0,
                                        cgst: x.cgst ? x.cgst + '%' : 0,
                                        igst: x.igst ? x.igst + '%' : 0,
                                        sgstAmt: x.sgstAmt ? x.sgstAmt : 0,
                                        cgstAmt: x.cgstAmt ? x.cgstAmt : 0,
                                        igstAmt: x.igstAmt ? x.igstAmt : 0,
                                        netTotal: x.netTotal ? x.netTotal : 0,
                                        remarks: x.remarks ? x.remarks : "",
                                        idMaterialTestingProducts: x.idMaterialTestingProducts ? x.idMaterialTestingProducts : 0,
                                        idMaterialTesting: x.idMaterialTesting ? x.idMaterialTesting : 0,
                                        idMaterialIssueJobWork: x.idMaterialIssueJobWork ? x.idMaterialIssueJobWork : 0,
                                        natureOJObWork: x.natureOJObWork ? x.natureOJObWork : "",
                                        issueNo: x.issueNo ? x.issueNo : "",
                                        rate: x.rate ? x.rate : 0,
                                        amount: x.amount ? x.amount : 0,
                                        actualRate: x.actualRate ? x.actualRate : 0,
                                        idMaterialJobWorkItems: x.idMaterialJobWorkItems ? x.idMaterialJobWorkItems : 0,
                                        idDisAssemble: x.idDisAssemble ? x.idDisAssemble : 0,
                                        idDisAssembleItems: x.idDisAssembleItems ? x.idDisAssembleItems : 0,
                                        inwardStatus: x.inwardStatus ? x.inwardStatus : 0,
                                        pendingQty: x.pendingQty ? x.pendingQty : 0,
                                    }
                                    materialJobWorkItemList.push(request);
                                });
                                let filteredData = this.state.roleId !== 1 ? materialJobWorkItemList.filter((x) => x.pendingQty > 0) : materialJobWorkItemList
                                this.setState({
                                    itemRowData: filteredData,
                                }, () => {
                                    this.resetItemDetailsFields();
                                    this.calculateTotal()
                                });
                            } else {
                                this.setState({ itemRowData: materialJobWorkItemList })
                            }
                        }
                    });

                }
            }
        });
    }

    handleOnClick = (event, name) => {
        if (this.state.materialObject.idVendor > 0) {
            this.setOpenModel2();
        } else {
            this.SwalServices.Alert("Please Select Vendor First");
        }
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.usp_Master_ItemSelectbyID_JobWork(event.data.idItem);
        });
    };


    downloadMaterialJobWorkInvoice = () => {
        if (this.state.materialObject.idMaterialJobWork > 0) {
            let request = [this.state.materialObject.idMaterialJobWork];
            this.transactionStockServices.downloadMaterialJobWorkInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    //var filename = `PurchaseInvoice-${moment(new Date()).format("DDMMYYYYHHmmss")}`;
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    downloadPendingMaterialJobWorkInvoice = () => {
        if (this.state.materialObject.idMaterialJobWork > 0) {
            let request = [this.state.materialObject.idMaterialJobWork];
            this.transactionStockServices.downloadPendingMaterialJobWorkInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    //var filename = `PurchaseInvoice-${moment(new Date()).format("DDMMYYYYHHmmss")}`;
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    shareOnWhatsApp = () => {
        if (this.state.materialObject.idMaterialJobWork > 0) {
            let request = [
                this.state.materialObject.idMaterialJobWork,
                "MaterialJobWork"
            ];
            this.transactionStockServices.shareOnWhatsApp(request).then((response) => {
                if (response.statusCode == 200 && response !== null) {
                    if (response.responseItem.responseContent) {
                        const link = response.responseItem.responseContent;
                        const phoneNumber = this.state.materialObject.contactNo || "";
                        const message = `Dear Customer ${this.state.materialObject.contactPerson || ""},  
    -> Please find attached your Material Job Work.  
    -> You can view or download it using the link below:    
    -> ${link}  
    
    Thank you for your business!`;
                        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                        window.open(whatsappLink, "_blank");
                    } else {
                        this.SwalServices.Error("No data found");
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }

    };

    sendOnEmail = () => {
        if (this.state.materialObject.idMaterialJobWork) {
            let request = [
                this.state.materialObject.email ? this.state.materialObject.email : "kumasanjaykumawat0412@gmail.com",
                this.state.materialObject.idMaterialJobWork,
                this.state.companyName,
                "MaterialJobWork"
                //"InvoiceTempletes\\PurchaseOrderInvoices"
            ];
            this.transactionStockServices.sendPurchaseInvoiceMail(request).then((response) => {
                if (response.responseItem !== null && response.statusCode === 200) {
                    this.SwalServices.Success("Invoice snet sucessfully.");
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("Email not data found");
        }
    };

    render() {
        return (
            <>
                <div className='manual-invoice'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                }}
                            />
                            <MaterialJobWorkPopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                materialObject={this.state.materialObject}
                                itemObject={this.state.itemObject}
                                handleChangeForWork={this.handleChangeForWork.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                close={this.closePopup.bind(this)}
                                validState={this.state.validState}
                                itemRowData={this.state.itemRowData}
                                itemColdefs={this.state.itemColdefs}
                                partyAccountList={this.state.partyAccountList}
                                accountHeadList={this.state.accountHeadList}
                                employeeList={this.state.employeeList}
                                itemCategoryList={this.state.itemCategoryList}
                                taxStructureList={this.state.taxStructureList}
                                plantList={this.state.plantList}
                                processList={this.state.processList}
                                invTyleList={this.state.invTyleList}
                                jobWorkFromLIst={this.state.jobWorkFromLIst}
                                setFilterParameters={this.setFilterParameters.bind(this)}
                                setFilterParametersForWork={this.setFilterParametersForWork.bind(this)}
                                itemList={this.state.itemList}
                                insertItem={this.insertItem.bind(this)}
                                types={this.state.types}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                                // handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                                onRowDoubleClickedForSalaryDetails={this.onRowDoubleClickedForSalaryDetails.bind(this)}
                                clearItem={this.resetItemDetailsFields.bind(this)}
                                deleteItem={this.deleteItem.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                downloadMaterialJobWorkInvoice={this.downloadMaterialJobWorkInvoice.bind(this)}
                                downloadPendingMaterialJobWorkInvoice={this.downloadPendingMaterialJobWorkInvoice.bind(this)}
                                sendOnEmail={this.sendOnEmail.bind(this)}
                                shareOnWhatsApp={this.shareOnWhatsApp.bind(this)}
                                usp_Users={this.state.usp_Users}
                                globalUserID={this.state.globalUserID}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 450px)" }}>
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material Job work</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        headerHeight={65}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        onCellClicked={this.handleCellClick}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.itemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
